function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.3122 5H3.68724C2.4815 5 1.49976 5.98175 1.49976 7.18752V16.8125C1.49976 18.0183 2.4815 19 3.68724 19H20.3122C21.5179 19 22.4997 18.0183 22.4997 16.8125V7.18752C22.4997 5.98175 21.518 5 20.3122 5ZM21.6247 16.8125C21.6247 17.5361 21.0359 18.125 20.3122 18.125H3.68724C2.9636 18.125 2.37474 17.5361 2.37474 16.8125V7.18752C2.37474 6.46389 2.9636 5.87503 3.68724 5.87503H20.3122C21.0358 5.87503 21.6247 6.46389 21.6247 7.18752V16.8125H21.6247Z",
  fill: "#112B45"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.0622 7.625H1.93727C1.69577 7.625 1.49976 7.82101 1.49976 8.06251V10.6875C1.49976 10.929 1.69577 11.125 1.93727 11.125H22.0622C22.3037 11.125 22.4998 10.929 22.4998 10.6875V8.06251C22.4997 7.82101 22.3037 7.625 22.0622 7.625ZM21.6247 10.25H2.37474V8.49998H21.6247V10.25H21.6247Z",
  fill: "#112B45"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.81226 13.75H4.56227C4.32077 13.75 4.12476 13.946 4.12476 14.1875C4.12476 14.429 4.32077 14.625 4.56227 14.625H9.81226C10.0538 14.625 10.2498 14.429 10.2498 14.1875C10.2498 13.946 10.0538 13.75 9.81226 13.75Z",
  fill: "#112B45"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.81226 15.5H4.56227C4.32077 15.5 4.12476 15.696 4.12476 15.9375C4.12476 16.179 4.32077 16.375 4.56227 16.375H9.81226C10.0538 16.375 10.2498 16.179 10.2498 15.9375C10.2497 15.696 10.0538 15.5 9.81226 15.5Z",
  fill: "#112B45"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5625 12.875H17.6875C16.9639 12.875 16.375 13.4639 16.375 14.1875V15.0625C16.375 15.7861 16.9639 16.375 17.6875 16.375H18.5625C19.2861 16.375 19.875 15.7861 19.875 15.0625V14.1875C19.875 13.4639 19.2861 12.875 18.5625 12.875ZM19 15.0625C19 15.304 18.804 15.5 18.5625 15.5H17.6875C17.446 15.5 17.25 15.304 17.25 15.0625V14.1875C17.25 13.946 17.446 13.75 17.6875 13.75H18.5625C18.804 13.75 19 13.946 19 14.1875V15.0625Z",
  fill: "#112B45"
});

const SvgCard = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/card.8ee31ec7.svg";
export { ForwardRef as ReactComponent };